import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  templateUrl: './dialog-updated.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DialogUpdatedComponent {
  constructor() { }
}
